import { Container } from "@material-ui/core";

import MainLayout from "@/layouts/MainLayout";
import IsBusinessModal from "../components/IsBusinessModal";
import Links from "@/constants/Links";

function BrokerTermsOfService() {
  return (
    <MainLayout>
      <Container>
        <h1>PRODUCER AGREEMENT</h1>
        <p>
          This Agreement is made and entered into by Lightsail Insurance
          Services LLC., (“Broker”) a Delaware corporation and you, a licensed
          retail agent (“Agent”) (each a “Party” and collectively “Parties”).
        </p>
        <p>
          Broker is a licensed property and casualty and excess surplus lines
          broker and in the business of placing contracts of insurance with
          various insurers (“Insurance Carriers”) who may or may not be admitted
          for business in the resident state(s) of the Agent’s customers
          (“Insureds”). Agent is a licensed property and casualty agent in good
          standing in each state where it conducts business, and hereby requests
          Broker to obtain coverage for the Agent’s Insureds.
        </p>
        <h3>Section 1. Agent’s Authority</h3>
        <p>
          Agent is not an agent for the Broker. Agent shall have no authority to
          make representations or to accept or bind risks on behalf of Broker or
          any Insurance Carrier(s). Agent shall not waive, alter, modify or
          change any of the terms, rates or conditions of any policy of
          insurance (“Policy” or “Policies”) issued pursuant to this Agreement.
        </p>
        <h3>Section 2. License of Broker/Errors and Omissions</h3>
        <p>
          Agent warrants that s/he is duly licensed as a property and casualty
          insurance agent in each state where Agent transacts business. Agent
          shall maintain, for two years from the date of this Agreement, an
          insurance agents’ Errors and Omission as well as a General Commercial
          Liability Policy, each with limits of no less than $1,000,000 per
          occurrence and $1,000,000 annual aggregate, issued by any insurer
          rated “A” or better by A. M. Best.
        </p>
        <h3>Section 3. Payment Responsibilities:</h3>
        <ol type="A">
          <li>
            <h4>General Principles</h4>
            <ol>
              <li>
                Agent shall be obligated to pay all premiums, fees and
                applicable taxes when due with respect to Policies, whether or
                not the same has collected from the Insured.
              </li>
              <li>
                All premiums, including return premiums, (“Premium”) received by
                Agent pursuant to this Agreement is the property of Broker.
                Agent shall hold such Premium in a fiduciary capacity, for
                Broker, in a separate FDIC member bank account until payment is
                remitted to Broker. Agent shall not commingle any Premium with
                any personal or business funds.
              </li>
              <li>
                Agent may deduct his/er Commission (defined below) from Premium
                only if s/he is not in default of any obligations under this
                Agreement.
              </li>
              <li>
                If any Insured defaults in payment of Premium and/or tax, Broker
                shall have the right to collect the same from the Insured.
                Broker’s collection efforts shall not relieve Agent of any
                obligation to pay the same. Agent will not receive Commissions
                on any (i) uncollected premium or (ii) where the Broker or
                Insurance Carrier(s) took over collection.
              </li>
              <li>
                Broker shall be entitled to reimbursement from the Agent for all
                costs incurred in its efforts to collect unpaid Premium. Broker
                shall be entitled to reimbursement for any penalties levied by
                any regulator or Surplus Lines Association due to Agent’s
                failure to timely remit any taxes or fees.
              </li>
              <li>
                Agent may prepay Premium and taxes due with respect to any
                Policy at the time it is bound. All additional Premium
                generated, by endorsement or audit, will be Broker Agency
                billed, and Agent shall pay Broker in accordance with section
                3.B, below.
              </li>
              <li>
                Agent may request that Broker undertake collections of Premium
                and taxes under any Policy.
              </li>
            </ol>
          </li>
          <li>
            <h4>Direct Billed Policies</h4>
            For business that is direct billed, Agent agrees as follows:
            <ol>
              <li>
                Insurance Carrier or Broker directly bills Insured for Premium,
                taxes and fees.
              </li>
              <li>
                Insured remits payment directly to Insurance Carrier or Broker.
              </li>
              <li>
                Broker pays Agent a commission, a percentage of Premium
                determined by Broker and disclosed to prior to binding, on each
                Policy written for Agent’s Insureds (“Commission”) within 45
                days of Broker’s receipt of payment.
              </li>
              <li>
                Agent is obligated to pay return commission to Broker, at the
                same rate as Agent’s commission, on any return Premium due to
                adjustments, cancellations, reductions or otherwise, within 45
                days of receipt of such request.
              </li>
            </ol>
          </li>
          <li>
            <h4>Agency Billed Policies</h4>
            For agency billed business, Agent is liable for all sums payable to
            Broker on Agent’s own and its Insureds behalf. Agent shall pay to
            Broker balances due on all certificates, policies, retrospective
            adjustments and other sums owed relating to insurance arranged by
            Broker for Agent’s Insureds, as follows:
            <ol>
              <li>
                Agent will pay Broker, regardless of the collectability or
                collection status, the Net Premiums (defined below) due
                (including applicable taxes), as reflected in Broker invoice(s),
                no later than twenty (20) days after the effective date of
                coverage, or on endorsements no later than twenty (20) days
                after receipt of Broker invoice. Net Premiums are defined as the
                policy premium and applicable taxes, less the Agent’s
                Commission.
              </li>
              <li>
                Agent may be relieved of responsibility to pay additional
                Premium resulting from a retrospective Premium adjustment or
                audit, if after Documented Effort on the part of the Agent to
                collect such additional Premium, the Agent notifies Broker
                within fifteen (15) days of receipt of the invoice or request
                for such additional Premium, Agent cannot collect such Premium.
                Documented Effort consists of two (2) written attempts, and one
                (1) documented telephonic attempt to collect such additional
                Premium.
              </li>
              <li>
                Agent will be obligated to pay return commission at the same
                rate as Agent’s Commission, on any return Premium due to
                adjustments, cancellations, reductions or otherwise, within 45
                days of request for return Premium. Broker shall have the right
                to offset any outstanding return commission or adjustment from
                any monies due Agent.
              </li>
            </ol>
          </li>
          <li>
            <h4>Financed Policies</h4>
            Agent will be responsible for notifying Broker of any Insured’s
            Policy financed by or through Agent.
          </li>
        </ol>
        <h3>Section 4. Agent Commissions</h3>
        <p>
          Broker will pay, as commissions, to Agent a percentage of the
          collected premium, net of surplus taxes and stamp duty, received by
          Broker at the rate of 17.5%, provided Agent has paid all amounts due
          Broker and is in compliance with the terms and conditions of the
          Agreement.
        </p>
        <ol type="A">
          <li>
            Agent acknowledges that Broker reserves the right to modify the
            commission rates set forth above, at any time.
          </li>
          <li>
            Agent agrees to promptly return to Broker all commissions at the
            same rate as paid Agent on all return premiums, including for
            cancellations. Agent may charge the insured a broker fee where
            permitted by law in addition to the compensation due Agent.
          </li>
          <li>
            Agent shall be responsible for all taxes, charges and assessments on
            amounts received by Agent as commissions under this Agreement.
          </li>
        </ol>
        <h3>Section 5. Cancellations of Insurance</h3>
        <p>
          Nothing contained herein shall be construed to limit or restrict any
          Broker or Insurance Carrier(s) right of cancellation in any binder,
          cover note, or Policy, including the right to cancel or rescind the
          Policy. Cancellation or rescission of a Policy terminates Agent’s
          right to any future Commissions. Agent shall not be entitled to any
          flat cancellation. In the event of cancellation, Agent shall be liable
          to Broker for any earned Premium, taxes and fees.
        </p>
        <h3>Section 6. Claims</h3>
        <p>
          Agent agrees to promptly report to Broker any fact, occurrence or
          incident that may result in a claim, loss or increased risk of loss
          under any Policy and immediately notify the Broker of any loss, claim
          or occurrence, upon discovery. Agent has no authority to handle,
          negotiate or settle claims.
        </p>
        <h3>Section 7. Inspections and Adjustments</h3>
        <p>
          Broker shall have the right to audit any Policy and inspect Agent’s
          books and records in connection therewith. Agent shall promptly report
          and pay Broker any additional or return premiums that may be due as a
          result of any adjustments.
        </p>
        <h3>Section 8. Confidentiality.</h3>
        <p>
          The terms and conditions of this Agreement are confidential between
          the parties and shall not be disclosed to anyone else, except as shall
          be necessary to effectuate its terms. Any disclosure in violation of
          this section shall be deemed a material breach of this Agreement.
          Broker shall keep the Insureds’ information confidential and will not
          use, disclose or share such information except as required by law or
          in connection with any contract between Broker and any insurance
          company.
        </p>
        <h3>Section 9. Intellectual Property</h3>
        <p>
          “Broker IP” means Broker&#39;s trademarks and/or service marks,
          certain documents, software and other works of authorship, other
          technology, hardware, products, processes, algorithms, user
          interfaces, know-how and other trade secrets, techniques, designs,
          inventions and other tangible or intangible technical material or
          information, and any other data, information and/or material provided
          by Broker to Agent. Agent shall not disclose, imitate, reverse
          engineer, or otherwise access or use any Broker IP, except in the
          performance of this Agreement.
        </p>
        <h3>Section 10. Indemnification</h3>
        <p>
          Agent agrees to indemnify and hold harmless Broker and its officers,
          directors, agents and employees from and against any and all claims,
          suits and demands of every kind and nature, including any and all
          actions, suits, judgments, losses, damages, costs, attorney&#39;s fees
          and expenses arising out of or in connection with:
          <ol>
            <li>Agent&#39;s violation of any law and/or regulation;</li>
            <li>Agent&#39;s material breach of any term of this Agreement;</li>
            <li>Agent&#39;s negligent or wrongful acts or omissions; or</li>
            <li>
              Criminal acts of Agent or personnel under Agent’s supervision.
            </li>
          </ol>
        </p>
        <h3>Section 11. Arbitration</h3>
        <p>
          Any dispute or difference between the parties arising from or relating
          to this Agreement, including its formation or validity, shall be
          submitted to a three-member arbitration panel. Each Party shall
          appoint an arbiter within thirty (30) days of the date of a demand for
          arbitration. The two Party-named arbitrators shall select an Umpire or
          in accordance with the AAA rules. The organizational meeting and
          hearing shall be held in San Francisco, CA and the proceedings shall
          be conducted in accordance with the AAA Rules and Procedures, unless
          the parties mutually agree otherwise. Each Party shall bear the
          expense of its own arbitrator and shall jointly and equally bear with
          the other Party the expense of the third arbitrator (umpire) and of
          the arbitration.
        </p>
        <h3>Section 12. Other Provisions</h3>
        <ol>
          <li>
            <span style={{ textDecoration: "underline" }}>Waiver</span>: No
            failure by either Party to require performance by the other Party of
            any provisions hereof shall be a waiver of such provisions and no
            waiver or amendment of any provision hereof shall be effective
            unless in writing.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>
              Entire Agreement
            </span>
            : This Agreement constitutes the entire agreement of the Parties and
            supersedes all prior agreements, whether written or oral.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>Governing Law</span>:
            This Agreement shall be governed by and construed in accordance with
            the laws of Colorado.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>Notice</span>: Any
            notice pursuant to this Agreement shall be delivered by electronic
            mail to support@getcyber.com.
          </li>
        </ol>
        <p>
          Execution of this Agreement constitutes full agreement and
          understanding between the parties with respect to each of the sections
          above. Agent acknowledges that he or she is doing business with
          Lightsail Insurance Services LLC. in an individual capacity, and he or
          she must personally sign the Agreement in his or her own name.
        </p>
      </Container>
    </MainLayout>
  );
}

function BusinessTermsOfService() {
  return (
    <MainLayout>
      <Container>
        <p>Last Modified: January 1, 2022</p>
        <h3>Acceptance of the Terms of Service</h3>
        <p>
          These Terms of Service are entered into by and between You (to include
          any company You are working on behalf of in accessing the Website) and
          Lightsail Insurance Services LLC (“<b>Company</b>,” “<b>we</b>,” or “
          <b>us</b>”). The following terms and conditions (“Terms of Service”)
          govern Your access to and use of www.getcyber.com, including any
          content, functionality and services offered on or through
          www.getcyber.com including in connection with the promotion and sale
          of insurance (whether offered through the Website, over the phone or
          otherwise), whether You are acting as a guest or a registered user
          (the “<b>Website</b>” or “<b>Services</b>
          ”).
        </p>
        <p>
          Please read the Terms of Service carefully before You start to use the
          Website.{" "}
          <b>
            By using the Website or by clicking to accept or agree to the Terms
            of Service when this option is made available to You, You accept and
            agree to be bound and abide by these Terms of Service and Our
            Privacy Policy, found at{" "}
            <a href={Links.PRIVACY_POLICY}>
              https://getcyber.com/privacy-policy
            </a>
            , incorporated herein by reference.
          </b>{" "}
          If You do not want to agree to these Terms of Service or the Privacy
          Policy, You must not access, use, or purchase insurance through the
          Website.
        </p>
        <p>
          This Website is offered and available to users who are 13 years of age
          or older and reside in the United States or any of its territories or
          possessions. By using this Website, You represent and warrant that You
          are of legal age to form a binding contract with the Company and meet
          all of the foregoing eligibility requirements. If You do not meet all
          of these requirements, You must not access or use the Website.
        </p>
        <h3>Changes to the Terms of Service</h3>
        <p>
          We may revise and update these Terms of Service from time to time in
          Our sole discretion. All changes are effective immediately when We
          post them and apply to all access to and use of the Website
          thereafter.
        </p>
        <p>
          Your continued use of the Website following the posting of revised
          Terms of Service means that You accept and agree to the changes. You
          are expected to check this page frequently so You are aware of any
          changes, as they are binding on You and Your company.
        </p>
        <h3>Accessing the Website and Account Security</h3>
        <p>
          We reserve the right to withdraw or amend this Website, and any of the
          Services or material We provide on the Website, in Our sole discretion
          without notice. We will not be liable if for any reason all or any
          part of the Website is unavailable at any time or for any period. From
          time to time, We may restrict access to some parts of the Website, or
          the entire Website, to users, including registered users.
        </p>
        <p>
          You are responsible for activities, including but not limited to: (1)
          making all arrangements necessary for You to have access to the
          Website; and (2) ensuring that all persons who access the Website
          through Your internet connection are aware of these Terms of Service
          and comply with them. Your credentials to access the Website are
          unique to You and should be protected and not be shared with others.
        </p>
        <p>
          To access the Website or some of the resources it offers, You may be
          asked to provide certain registration details or other information. It
          is a condition of Your use of the Website that all the information You
          provide on the Website is correct, current and complete. You agree
          that all information You provide to register with this Website or
          otherwise, including, but not limited to, through the use of any
          interactive features on the Website, is governed by Our{" "}
          <a href={Links.PRIVACY_POLICY}>Privacy Policy</a>, and You consent to
          all actions We take with respect to Your information consistent with
          Our Privacy Policy.
        </p>
        <p>
          If You choose, or are provided with, a user name, password or any
          other piece of information as part of Our security procedures, You
          must treat such information as confidential, and You must not disclose
          it to any other person or entity. You also acknowledge that Your
          account is personal to You and agree not to provide any other person
          with access to this Website or portions of it using Your user name,
          password or other security information. You agree to notify Us
          immediately of any unauthorized access to or use of Your user name or
          password or any other breach of security. You also agree to ensure
          that You exit from Your account at the end of each session. You should
          use particular caution when accessing Your account from a public or
          shared computer so that others are not able to view or record Your
          password or other personal information.
        </p>
        <p>
          We have the right to disable any user name, password or other
          identifier, whether chosen by You or provided by us, at any time in
          Our sole discretion for any or no reason, including if, in Our
          opinion, You have violated any provision of these Terms of Service.
        </p>
        <h3>Intellectual Property Rights</h3>
        <p>
          The Website and its entire contents, features and functionality
          (including but not limited to all information, software, text,
          displays, images, video and audio, and the design, selection and
          arrangement thereof), are owned by the Company, its licensors or other
          providers of such material and are protected by United States and
          international copyright, trademark, patent, trade secret and other
          intellectual property or proprietary rights laws.
        </p>
        <p>
          These Terms of Service permit You to use the Website for Your
          personal, non-commercial use only. You must not reproduce, distribute,
          modify, create derivative works of, publicly display, publicly
          perform, republish, download, store or transmit any of the material on
          Our Website, except as follows:
          <ul>
            <li>
              Your computer may temporarily store copies of such materials in
              RAM incidental to Your accessing and viewing those materials.
            </li>
            <li>
              You may store files that are automatically cached by Your Web
              browser for display enhancement purposes.
            </li>
            <li>
              You may print one copy of a reasonable number of pages of the
              Website for Your own personal, non-commercial use and not for
              further reproduction, publication or distribution.
            </li>
            <li>
              If We provide desktop, mobile or other applications for download,
              You may download a single copy to Your computer or mobile device
              solely for Your own personal, non-commercial use, provided You
              agree to be bound by Our end user license agreement for such
              applications.
            </li>
          </ul>
        </p>
        <p>
          You must not:
          <ul>
            <li>Modify copies of any materials from this site.</li>
            <li>
              Delete or alter any copyright, trademark or other proprietary
              rights notices from copies of materials from this site.
            </li>
            <li>
              Upload to the Website any materials that are the intellectual
              property of, or proprietary to, another person or entity.
            </li>
          </ul>
        </p>
        <p>
          You must not access or use for any commercial purposes any part of the
          Website or any services or materials available through the Website.
        </p>
        <p>
          If We detect that You printed, copied, modified, downloaded or
          otherwise used or provided any other person with access to any part of
          the Website in breach of the Terms of Service, Your right to use the
          Website will cease immediately and You must, at Our option, return or
          destroy any copies of the materials You have made. No right, title or
          interest in or to the Website or any content on the Website is
          transferred to You, and all rights not expressly granted are reserved
          by the Company. Any use of the Website not expressly permitted by
          these Terms of Service is a breach of these Terms of Service and may
          violate copyright, trademark and other laws.
        </p>
        <h3>Trademarks</h3>
        <p>
          The Company name, the terms “getcyber”, “Lightsail”, the Company logo
          and all related names, logos, product and service names, designs and
          slogans are trademarks of the Company or its affiliates or licensors.
          You must not use such marks without the prior written permission of
          the Company. All other names, logos, product and service names,
          designs and slogans on this Website are the trademarks of their
          respective owners.
        </p>
        <h3>Prohibited Uses</h3>
        <p>
          You may use the Website only for lawful purposes and in accordance
          with these Terms of Service. You agree not to use the Website:
          <ul>
            <li>
              In any way that violates any applicable federal, state, local or
              international law or regulation (including, without limitation,
              any laws regarding the export of data or software to and from the
              US or other countries).
            </li>
            <li>
              For the purpose of exploiting, harming or attempting to exploit or
              harm minors in any way by exposing them to inappropriate content,
              asking for personally identifiable information or otherwise.
            </li>
            <li>
              To send, knowingly receive, upload, download, use or re-use any
              material which does not comply with the Content Standards set out
              in these Terms of Service.
            </li>
            <li>
              To transmit, or procure the sending of, any advertising or
              promotional material, including any “junk mail,” “chain letter,”
              “spam,” or any other similar solicitation.
            </li>
            <li>
              To impersonate or attempt to impersonate the Company, a Company
              employee, another user or any other person or entity (including,
              without limitation, by using e-mail addresses associated with any
              of the foregoing).
            </li>
            <li>
              To engage in any other conduct that restricts or inhibits anyone’s
              use or enjoyment of the Website, or which, as determined by us,
              may harm the Company or users of the Website, or expose them to
              liability.
            </li>
          </ul>
        </p>
        <p>
          Additionally, You agree not to:
          <ul>
            <li>
              Use the Website in any manner that could disable, overburden,
              damage, or impair the site or interfere with any other party’s use
              of the Website, including their ability to engage in real time
              activities through the Website.
            </li>
            <li>
              Use any robot, spider or other automatic device, process or means
              to access the Website for any purpose, including monitoring or
              copying any of the material on the Website.
            </li>
            <li>
              Use any manual process to monitor or copy any of the material on
              the Website, or for any other purpose not expressly authorized in
              these Terms of Service, without Our prior written consent.
            </li>
            <li>
              Use any device, software or routine that interferes with the
              proper working of the Website.
            </li>
            <li>
              Introduce any viruses, trojan horses, worms, logic bombs or other
              material which is malicious or technologically harmful.
            </li>
            <li>
              Attempt to gain unauthorized access to, interfere with, damage or
              disrupt any parts of the Website, the server on which the Website
              is stored, or any server, computer or database connected to the
              Website.
            </li>
            <li>
              Attack the Website via a denial-of-service attack or a distributed
              denial-of-service attack.
            </li>
            <li>
              Otherwise attempt to interfere with the proper working of the
              Website.
            </li>
          </ul>
        </p>
        <h3>User Contributions</h3>
        <p>
          The Website may, or may in the future, contain message boards, chat
          rooms, personal web pages or profiles, forums, bulletin boards, and
          other interactive features (collectively, “Interactive Services”) that
          allow users to post, submit, publish, display or transmit to other
          users or other persons (hereinafter, “post”) content or materials
          (collectively, “User Contributions”) on or through the Website.
        </p>
        <p>
          All User Contributions must comply with the Content Standards set out
          in these Terms of Service.
        </p>
        <p>
          Any User Contribution You post to the site will be considered
          non-confidential and non-proprietary. By providing any User
          Contribution on the Website, You grant Us and Our affiliates and
          service providers, and each of their and Our respective licensees,
          successors and assigns the right to use, reproduce, modify, perform,
          display, distribute and otherwise disclose to third parties any such
          material for any purpose.
        </p>
        <p>
          You represent and warrant that:
          <ul>
            <li>
              You own or control all rights in and to the User Contributions and
              have the right to grant the license granted above to Us and Our
              affiliates and service providers, and each of their and Our
              respective licensees, successors and assigns.
            </li>
            <li>
              All of Your User Contributions do and will comply with these Terms
              of Service.
            </li>
          </ul>
        </p>
        <p>
          You understand and acknowledge that You are responsible for any User
          Contributions You submit or contribute, and You, not the Company, have
          full responsibility for such content, including its legality,
          reliability, accuracy and appropriateness.
        </p>
        <p>
          We are not responsible, or liable to any third party, for the content
          or accuracy of any User Contributions posted by You or any other user
          of the Website.
        </p>
        <h3>Communications from Us</h3>
        <p>
          You agree to receive communications, including emails, text messages,
          push notifications, mail and telephone calls related to the Services.
          You also agree that any communications may include marketing from Us
          or third parties and that any notices, agreements, disclosures or
          other communications constitute satisfactory delivery. You may opt out
          from receiving any marketing communications from Us by emailing{" "}
          <a href="mailto:unsubscribe@getcyber.com">unsubscribe@getcyber.com</a>
          .
        </p>
        <h3>Compensation and Fee Disclosure</h3>
        <p>
          We are authorized, on behalf of admitted and surplus carriers, to
          confer with insureds and potential insureds about the terms and
          conditions of a variety of insurance products and coverage options. We
          are compensated for Our work in this role by commissions paid by
          insurers and, at times, fees paid by insureds. Insurance companies
          determine the amount of commissions paid to Us as a percentage of
          premium. Commission is fully earned at policy inception, meaning that
          We may retain it regardless of cancellation or reduction of coverage,
          except where prohibited by law. We may also be entitled to contingent
          commissions depending on certain business criteria set forth by
          insurers.{" "}
        </p>
        <p>
          We may also charge fees for insurance policies where permitted by law.
          The placement of certain surplus coverages may also include fees from
          states or state stamping offices, which are passed on to insureds.{" "}
        </p>
        <h3>Service and Product Availability</h3>
        <p>
          Some services or products may be limited to consumers only in those
          United States jurisdictions in which We, one of Our affiliates, or
          commercial partners are licensed to sell those services or products.
          The Website is not intended as a solicitation for insurance in any
          state where We, Our affiliates, or a business partner is not licensed.
          None of the Website information should be viewed as an offer to sell
          or solicit any particular insurance product or coverage. We reserve
          the right to limit products or services to any person within any
          jurisdiction where any offer for such products or services is void
          where prohibited by law.
        </p>
        <p>
          We make no representation of coverage for any claim or loss under any
          policy of insurance. Any coverage provided is subject to the terms,
          conditions, limitations and exclusions for that particular policy as
          issued by the insurer. In no event shall the representations contained
          in the services be determinative of coverage. Should there be any
          discrepancy between a description of coverage through the Website and
          the terms of an insurance policy, the terms of the insurance policy
          shall prevail.
        </p>
        <h3>Surplus Lines Products</h3>
        <p>
          Certain coverages described on this website may not be available in
          the admitted market but may be available on a surplus lines basis.
          This means the insurance is available only through properly licensed
          excess and surplus lines brokers in accordance with applicable surplus
          lines laws. Placement of this coverage may be with insurers not
          licensed to transact insurance in Your jurisdiction and therefore not
          subject to the same laws and regulations governing admitted insurers.
          Policy forms, conditions, premium, and deductibles may differ from
          those found in policies utilized in the admitted market. A state
          insurance guaranty fund will not support the coverage in the event the
          surplus lines insurer becomes insolvent.
        </p>
        <p>
          The insured is responsible for all insurance premium and any
          applicable surplus lines, sales, use, excise or other taxes for
          coverage placed by Us or Our partner intermediaries. Failure to timely
          and fully pay premium as well as any applicable taxes or fees may
          result in cancellation of coverage.
        </p>
        <p>
          Any descriptions of potentially available surplus lines products are
          not an offer to sell or solicit surplus insurance to the general
          public.
        </p>
        <h3>Insurers</h3>
        <p>
          We are not obligated to use any particular insurer. Except where We
          expressly inform You, We are not authorized to make binding
          commitments on behalf of any carrier. We have no responsibility for
          any carrier’s solvency, payment of any claims or any other financial
          obligations. We cannot guarantee that coverage may be placed with any
          carrier despite Our efforts to do so.
        </p>
        <h3>Our Use of Intermediaries</h3>
        <p>
          There may be situations where it is necessary or advantageous for Us
          to use third party intermediaries to serve You. These intermediaries
          may be compensated by commissions or other fees earned by placing
          coverage or by separate fee agreed to and paid by You. This
          compensation may be in addition to the compensation due to Us or an
          insurer.
        </p>
        <h3>Accuracy and Completeness of Information Provided by You</h3>
        <p>
          You are solely and completely responsible for the accuracy and
          completeness of all information You provide—on behalf of Yourself or
          Your company—to Us or Our partner underwriters, insurers,
          intermediaries, or other third parties. This includes information
          furnished on policy documents and applications prepared by Us or Our
          partners, which You shall be responsible for revising for
          inaccuracies, deficiencies or discrepancies. We shall have no
          responsibility to You or third parties for the information You provide
          and shall have no responsibility to independently verify such
          information. You warrant that We may reasonably rely on all such
          information in providing You with the services contemplated herein. We
          shall have no liability for any errors or omissions that arise from,
          in whole or in part, any lack of accuracy and completeness in the
          information You provide. You further acknowledge and understand that
          any failure to provide complete and accurate information may result in
          a denial of Your claims or a rescission of coverage.
        </p>
        <h3>Third Party Service and Product Offerings</h3>
        <p>
          We may offer third party applications, products or services that are
          integrated with, or otherwise accessible through, the Website (“
          <b>Third Party Products or Services</b>”). The use of these Third
          Party Products or Services is governed solely by the applicable third
          party end user terms of use, privacy policy, or similar agreements. In
          cases that will be made clear and with Your permission, You authorize
          Us to act and share Your information on Your behalf to such third
          parties.{" "}
        </p>
        <p>
          Prior to relying on or using any third party information, website or
          Third Party Products or Services, You should conduct Your own review
          of the website and related terms of use and similar agreements. If You
          do not wish to agree to the applicable end user terms of use and
          related agreements, then You may not access or use the Third Party
          Products or Services. Company shall not be responsible or held liable
          for any damage or loss arising from any Third Party Products or
          Services.
        </p>
        <h3>Monitoring and Enforcement; Termination</h3>
        <p>
          We have the right but not the responsibility to:
          <ul>
            <li>
              Remove or refuse to post any User Contributions for any or no
              reason in Our sole discretion.
            </li>
            <li>
              Take any action with respect to any User Contribution that We deem
              necessary or appropriate in Our sole discretion, including if We
              believe that such User Contribution violates the Terms of Service,
              including the Content Standards, infringes any intellectual
              property right or other right of any person or entity, threatens
              the personal safety of users of the Website or the public or could
              create liability for the Company.
            </li>
            <li>
              Disclose Your identity or other information about You to any third
              party who claims that material posted by You violates their
              rights, including their intellectual property rights or their
              right to privacy.
            </li>
            <li>
              Take appropriate legal action, including without limitation,
              referral to law enforcement, for any illegal or unauthorized use
              of the Website.{" "}
            </li>
            <li>
              Terminate or suspend Your access to all or part of the Website for
              any or no reason, including without limitation, any violation of
              these Terms of Service.
            </li>
          </ul>
        </p>
        <p>
          Without limiting the foregoing, We have the right to fully cooperate
          with any law enforcement authorities or court order requesting or
          directing Us to disclose the identity or other information of anyone
          posting any materials on or through the Website. YOU WAIVE AND HOLD
          HARMLESS THE COMPANY AND ITS AFFILIATES, LICENSEES AND SERVICE
          PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY ANY OF
          THE FOREGOING PARTIES DURING OR AS A RESULT OF ITS INVESTIGATIONS AND
          FROM ANY ACTIONS TAKEN AS A CONSEQUENCE OF INVESTIGATIONS BY EITHER
          SUCH PARTIES OR LAW ENFORCEMENT AUTHORITIES.
        </p>
        <p>
          However, We do not undertake to review material before it is posted on
          the Website, and cannot ensure prompt removal of objectionable
          material after it has been posted. Accordingly, We assume no liability
          for any action or inaction regarding transmissions, communications or
          content provided by any user or third party. We have no liability or
          responsibility to anyone for performance or nonperformance of the
          activities described in this section.
        </p>
        <h3>Content Standards</h3>
        <p>
          These content standards apply to any and all User Contributions and
          use of Interactive Services. User Contributions must in their entirety
          comply with all applicable federal, state, local and international
          laws and regulations. Without limiting the foregoing, User
          Contributions must not:
          <ul>
            <li>
              Contain any material which is defamatory, obscene, indecent,
              abusive, offensive, harassing, violent, hateful, inflammatory, a
              nuisance or otherwise objectionable.
            </li>
            <li>
              Promote sexually explicit or pornographic material, violence, or
              discrimination based on race, sex, religion, nationality,
              disability, sexual orientation or age.
            </li>
            <li>
              Infringe any patent, trademark, trade secret, copyright or other
              intellectual property or other rights of any other person.
            </li>
            <li>
              Violate the legal rights (including the rights of publicity and
              privacy) of others or contain any material that could give rise to
              any civil or criminal liability under applicable laws or
              regulations or that otherwise may be in conflict with these Terms
              of Service and Our{" "}
              <a href={Links.PRIVACY_POLICY}>Privacy Policy</a>.
            </li>
            <li>Be likely to deceive any person.</li>
            <li>
              Promote any illegal activity, or advocate, promote or assist any
              unlawful act.
            </li>
            <li>
              Cause annoyance, inconvenience or needless anxiety or be likely to
              upset, embarrass, alarm or annoy any other person.
            </li>
            <li>
              Impersonate any person, or misrepresent Your identity or
              affiliation with any person or organization.{" "}
            </li>
            <li>
              Involve commercial activities or sales, such as contests,
              sweepstakes and other sales promotions, barter or advertising.
            </li>
            <li>
              Give the impression that they emanate from or are endorsed by Us
              or any other person or entity, if this is not the case.
            </li>
          </ul>
        </p>
        <h3>Reliance on Information Posted</h3>
        <p>
          The information presented on or through the Website is made available
          solely for general information purposes. We do not warrant the
          accuracy, completeness or usefulness of this information. Any reliance
          You place on such information is strictly at Your own risk. We
          disclaim all liability and responsibility arising from any reliance
          placed on such materials by You or any other visitor to the Website,
          or by anyone who may be informed of any of its contents.
        </p>
        <p>
          This Website may include content provided by third parties, including
          materials provided by other users, bloggers and third-party licensors,
          syndicators, aggregators and/or reporting services. All statements
          and/or opinions expressed in these materials, and all articles and
          responses to questions and other content, other than the content
          provided by the Company, are solely the opinions and the
          responsibility of the person or entity providing those materials.
          These materials do not necessarily reflect the opinion of the Company.
          We are not responsible, or liable to You or any third party, for the
          content or accuracy of any materials provided by any third parties.
        </p>
        <h3>Changes to the Website</h3>
        <p>
          We may update the content on this Website from time to time, but its
          content is not necessarily complete or up-to-date. Any of the material
          on the Website may be out of date at any given time, and We are under
          no obligation to update such material.
        </p>
        <h3>Information About You and Your Visits to the Website</h3>
        <p>
          All information We collect on this Website is subject to Our{" "}
          <a href={Links.PRIVACY_POLICY}>Privacy Policy</a>. By using the
          Website, You consent to all actions taken by Us with respect to Your
          information in compliance with the Privacy Policy. You grant to Us, to
          the greatest extent permissible by law, a non-exclusive, royalty-free,
          fully-paid, worldwide license to use and process Your data as
          reasonably necessary for Us to provide You with the services through
          the Website as well as Third Party Products or Services. We encourage
          You to review and familiarize Yourself with any terms and conditions
          or privacy policies of any third party sites You access directly or
          indirectly via the Website as We are not responsible for those third
          party’s separate and unique terms, conditions and privacy practices.
        </p>
        <h3>Linking to the Website and Social Media Features</h3>
        <p>
          You may link to Our homepage, provided You do so in a way that is fair
          and legal and does not damage or materially alter Our reputation or
          take advantage of it, but You must not establish a link in such a way
          as to suggest any form of association, approval or endorsement on Our
          part without Our prior express written consent.
        </p>
        <p>
          This Website may provide certain social media features that enable You
          to:
          <ul>
            <li>
              Link from Your own or certain third-party websites to certain
              content on this Website.
            </li>
            <li>
              Send e-mails or other communications with certain content, or
              links to certain content, on this Website.
            </li>
            <li>
              Cause limited portions of content on this Website to be displayed
              or appear to be displayed on Your own or certain third-party
              websites.
            </li>
          </ul>
        </p>
        <p>
          You may use these features solely as they are provided by Us and
          solely with respect to the content they are displayed with. Subject to
          the foregoing, You must not:
          <ul>
            <li>Establish a link from any website that is not owned by You.</li>
            <li>
              Cause the Website or portions of it to be displayed, or appear to
              be displayed by, for example, framing, deep linking or in-line
              linking, on any other site.
            </li>
            <li>Link to any part of the Website other than the homepage.</li>
            <li>
              Otherwise take any action with respect to the materials on this
              Website that is inconsistent with any other provision of these
              Terms of Service.
            </li>
          </ul>
        </p>
        <p>
          You agree to cooperate with Us in causing any unauthorized framing or
          linking immediately to cease. We reserve the right to withdraw linking
          permission without notice.
        </p>
        <p>
          We may disable all or any social media features and any links at any
          time without notice in Our discretion.
        </p>
        <h3>Links from the Website</h3>
        <p>
          If the Website contains links to other sites and resources provided by
          third parties, these links are provided for Your convenience only.
          This includes links contained in advertisements, including banner
          advertisements and sponsored links. We have no control over the
          contents of those sites or resources, and accept no responsibility for
          them or for any loss or damage that may arise from Your use of them.
          If You decide to access any of the third party websites linked to this
          Website, You do so entirely at Your own risk and subject to the terms
          and conditions of use for such websites.
        </p>
        <h3>Geographic Restrictions</h3>
        <p>
          The owner of the Website is based in California in the United States.
          We provide this Website for use only by persons located in the United
          States. We make no claims that the Website or any of its content is
          accessible or appropriate outside of the United States. Access to the
          Website may not be legal by certain persons or in certain countries.
          If You access the Website from outside the United States, You do so on
          Your own initiative and are responsible for compliance with local
          laws.
        </p>
        <h3>Disclaimer of Warranties</h3>
        <p>
          You understand that We cannot and do not guarantee or warrant that
          files available for downloading from the internet or the Website will
          be free of viruses or other destructive code. You are responsible for
          implementing sufficient procedures and checkpoints to satisfy Your
          particular requirements for anti-virus protection and accuracy of data
          input and output, and for maintaining a means external to Our site for
          any reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY
          LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK,
          VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR
          COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY
          MATERIAL DUE TO YOUR USE OF THE WEBSITE OR ANY SERVICES OR ITEMS
          OBTAINED THROUGH THE WEBSITE OR TO YOUR DOWNLOADING OF ANY MATERIAL
          POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
        </p>
        <p>
          YOUR USE OF THE WEBSITE, ITS CONTENT AND ANY SERVICES OR ITEMS
          OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE WEBSITE, ITS
          CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE
          PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT ANY
          WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER THE COMPANY
          NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES ANY WARRANTY OR
          REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY,
          RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE WEBSITE. WITHOUT
          LIMITING THE FOREGOING, NEITHER THE COMPANY NOR ANYONE ASSOCIATED WITH
          THE COMPANY REPRESENTS OR WARRANTS THAT THE WEBSITE, ITS CONTENT OR
          ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL BE ACCURATE,
          RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED,
          THAT OUR SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF
          VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE WEBSITE OR ANY
          SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL OTHERWISE MEET
          YOUR NEEDS OR EXPECTATIONS.{" "}
        </p>
        <p>
          THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER
          EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED
          TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR
          PARTICULAR PURPOSE.
        </p>
        <p>
          THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED
          OR LIMITED UNDER APPLICABLE LAW.
        </p>
        <h3>Limitation on Liability</h3>
        <p>
          TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COLLECTIVE
          LIABILITY OF THE COMPANY AND ITS SUBSIDIARIES AND AFFILIATES, AND
          THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, AND
          DIRECTORS, TO ANY PARTY (REGARDLESS OF THE FORM OF ACTION, WHETHER IN
          CONTRACT, TORT, OR OTHERWISE) EXCEED THE GREATER OF $50 OR THE AMOUNT
          PAID TO THE COMPANY AS COMMISSION ON INSURANCE SOLD TO YOU IN THE LAST
          6 MONTHS OUT OF WHICH LIABILITY AROSE.
        </p>
        <p>
          The limitation of liability set out above does not apply to liability
          resulting from Our gross negligence or willful misconduct.
        </p>
        <p>
          THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED
          OR LIMITED UNDER APPLICABLE LAW.
        </p>
        <h3>Indemnification</h3>
        <p>
          You agree to defend, indemnify and hold harmless the Company, its
          affiliates, licensors and service providers, and its and their
          respective officers, directors, employees, contractors, agents,
          licensors, suppliers, successors and assigns from and against any
          claims, liabilities, damages, judgments, awards, losses, costs,
          expenses or fees (including reasonable attorneys’ fees) arising out of
          or relating to Your violation of these Terms of Service or Your use of
          the Website, including, but not limited to, Your User Contributions,
          any use of the Website’s content, services and products other than as
          expressly authorized in these Terms of Service, or Your use of any
          information obtained from the Website.
        </p>
        <h3>Copyright or Trademark Infringement Claims</h3>
        <p>
          If You believe in good faith that Website materials infringe Your
          copyright or trademark rights, You may send Us a notice requesting
          that the material be removed, or access to it blocked. The notice must
          include all of the following: (i) an electronic or physical signature
          of the copyright owner or a person authorized to act on the owner’s
          behalf; (ii) a description of the copyrighted works claimed to have
          been infringed; (iii) a description of the infringing material and
          information reasonably sufficient to permit Company to locate the
          material; (iv) contact information for the complaining party,
          including address, telephone number and email address; (v) a statement
          that the complaining party has a good-faith belief that use of the
          material in the manner complained of is not authorized by the
          copyright or trademark owner, its agent, or the law; and (vi) a
          statement that the information in the notification is accurate and,
          under penalty of perjury, that the complaining party is authorized to
          act on behalf of the owner of an exclusive right that is allegedly
          infringed.{" "}
        </p>
        <p>
          Please be advised that the Company will not respond to complaints that
          do not meet these requirements. If Company determines that the
          materials alleged to infringe Your copyright or trademark rights do
          not require removal, Company will remove those materials only pursuant
          to a court order declaring the content or use of the materials
          unlawful.
        </p>
        <p>
          If You believe in good faith that a notice of copyright infringement
          has been wrongly filed against You, the Digital Millennium Copyright
          Act, Public Law 105-304 (the “DMCA”) permits You to send Us a
          counter-notice. Counter-notices must include the following
          information: (a) Your name, address, and telephone number; (b) the
          source of the content that was removed; (c) a statement under penalty
          of perjury that You have a good-faith belief that the content was
          removed in error; (d) a statement that You consent to the jurisdiction
          of Federal District Court for the judicial district in which Your
          address is located; or, if Your address is outside of the United
          States, for any judicial district in which Company may be found, and
          that You will accept service of process from the person who provided
          the original complaint; and (e) a physical or electronic signature
          (for example, typing Your full name).
        </p>
        <p>
          Notices and counter-notices with respect to the Applications must meet
          the then-current statutory requirements imposed by the DMCA (see
          http://www.loc.gov/copyright for details) and should be sent to the
          agent identified below. We suggest that You consult Your legal advisor
          before filing a notice or counter-notice. Also, be aware that there
          can be penalties for false claims under the DMCA.
        </p>
        <p>
          Agent to Receive Notices of Claimed Infringement:
          <address>
            <a href="mailto:dmca@getcyber.com">dmca@getcyber.com</a>
            <br />
            Attn: DMCA Complaints
            <br />
            Lightsail Insurance Services, LLC
            <br />
            2093 PHILADELPHIA PIKE #3809
            <br />
            CLAYMONT, DE 19703
          </address>
        </p>
        <h3>Governing Law and Jurisdiction</h3>
        <p>
          All matters relating to the Website and these Terms of Service, and
          any dispute or claim arising therefrom or related thereto (in each
          case, including non-contractual disputes or claims), shall be governed
          by and construed in accordance with the internal laws of the State of
          California without giving effect to any choice or conflict of law
          provision or rule (whether of the State of California or any other
          jurisdiction).
        </p>
        <p>
          Any legal suit, action or proceeding arising out of, or related to,
          these Terms of Service or the Website shall be instituted exclusively
          in the federal courts of the United States or the courts of the State
          of New York, in each case located in the City of New York and County
          of New York County, although We retain the right to bring any suit,
          action or proceeding against You for breach of these Terms of Service
          in Your country of residence or any other relevant country. You waive
          any and all objections to the exercise of jurisdiction over You by
          such courts and to venue in such courts.
        </p>
        <h3>Dispute Resolution</h3>
        <p>
          <b>Read this Section carefully, as it affects Your rights. </b>
        </p>
        <p>
          All claims and disputes arising out of or related to this Agreement
          shall be finally and fully settled by binding arbitration administered
          by the JAMS Alternative Dispute Resolution (“JAMS”) in accordance with
          its Commercial Arbitration Rules and procedures for consumer-related
          disputes, with the exception of any rules or procedures allowing for
          class actions. The arbitrator shall have exclusive authority and
          jurisdiction to resolve all claims and disputes arising from this
          Agreement, including but not limited to a claim that this Agreement is
          void in whole or in part. The arbitrator’s award may be confirmed in
          any court of competent jurisdiction. Any arbitration will be held in
          the state of Texas or the United States county where You live or work.
          Any party seeking arbitration must first send to the other, by
          certified mail, written notice of the dispute.
        </p>
        <p>
          You agree that any arbitration or court procedure shall be conducted
          on an individual basis and not as a class action or other
          representative action. Should any court or arbitrator determine that
          this class action waiver is void or unenforceable for any reason, or
          that an arbitration may proceed on a class basis, then the arbitration
          provision set forth above shall be deemed null and void in its
          entirety and the parties shall be deemed to have not agreed to
          arbitrate any dispute.
        </p>
        <p>
          You have the right to opt out of the arbitration and class action
          waiver provisions set forth above by sending written notice of this
          decision to the address listed at the end of this Terms of Use. If You
          duly notify Us of Your decision to opt out, We shall also not be bound
          by these provisions. Such notice must be sent within thirty (30) days
          of registering to use the Website to be effective. Regardless of
          notice, all other terms remain in full force.
        </p>
        <h3>Limitation on Time to File Claims</h3>
        <p>
          ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING
          TO THESE TERMS OF USE OR THE WEBSITE MUST BE COMMENCED WITHIN ONE (1)
          YEAR AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE, SUCH CAUSE OF
          ACTION OR CLAIM IS PERMANENTLY BARRED.
        </p>
        <h3>Waiver and Severability</h3>
        <p>
          No waiver of by the Company of any term or condition set forth in
          these Terms of Service shall be deemed a further or continuing waiver
          of such term or condition or a waiver of any other term or condition,
          and any failure of the Company to assert a right or provision under
          these Terms of Service shall not constitute a waiver of such right or
          provision.
        </p>
        <p>
          If any provision of these Terms of Service is held by a court or other
          tribunal of competent jurisdiction to be invalid, illegal or
          unenforceable for any reason, such provision shall be eliminated or
          limited to the minimum extent such that the remaining provisions of
          the Terms of Service will continue in full force and effect.
        </p>
        <h3>Entire Agreement</h3>
        <p>
          The Terms of Service, Our Privacy Policy, Terms of Sale, and the terms
          and provisions of any insurance contract and the accompanying notices
          and documentation provided by the insured constitute the sole and
          entire agreement between you and Lightsail Insurance Services, LLC.
          with respect to the Website and supersede all prior and
          contemporaneous understandings, agreements, representations and
          warranties, both written and oral, with respect to the Website.
        </p>
        <h3>Your Comments and Concerns</h3>
        <p>
          This website is operated by Lightsail Insurance Services, LLC., 2093
          PHILADELPHIA PIKE #3809 CLAYMONT, DE 19703
        </p>
        <p>
          All other feedback, comments, requests for technical support and other
          communications relating to the Website should be directed to:{" "}
          <a href="mailto:support@getcyber.com">support@getcyber.com</a>.
        </p>
      </Container>
    </MainLayout>
  );
}

export default function TermsOfService() {
  return (
    <IsBusinessModal
      businessRoute={Links.ToS}
      businessComponent={<BusinessTermsOfService />}
      brokerRoute={Links.ToS}
      brokerComponent={<BrokerTermsOfService />}
    />
  );
}
